<div class="row">
  <div class="col-12 checkout-flow-shell" style="width: 100%">
    <div style="display: none">{{ host.notification?.data?.wash_type | json }}</div>
    <!-- Payment Link Sent Message with Timer -->
    <div
      *ngIf="host.paymentLinkSent && host.paymentForm.method === host.PaymentMethodCode.Link"
      class="payment-link-sent-container"
    >
      <!-- Illustration and Timer -->
      <div class="illustration-section">
        <!-- Payment Link Illustration -->
        <div class="illustration">
          <img
            src="assets/images/payment-link-sent/payment-link-illustration.svg"
            alt="Payment Link Sent"
            width="180"
            height="180"
          />
        </div>

        <!-- Timer -->
        <div class="timer-container">
          <div class="timer-box">
            <div class="timer-section">
              <div class="timer-number">{{ host.formattedPaymentMinutes }}</div>
              <div class="timer-label">Minutes</div>
            </div>
            <div class="timer-section">
              <div class="timer-number">{{ host.formattedPaymentSeconds }}</div>
              <div class="timer-label">Seconds</div>
            </div>
            <div class="timer-separator">:</div>
          </div>
        </div>
      </div>

      <!-- Text Content -->
      <div class="text-section">
        <div class="text-content">
          <h2 class="modal-title" *ngIf="!host.paymentExpired">Payment link has been sent!</h2>
          <h2 class="modal-title expired-title" *ngIf="host.paymentExpired">Payment Expired</h2>
          <p class="modal-description" *ngIf="!host.paymentExpired">
            Payment link sent to {{ host.formattedPaymentPhoneNumber }}. Awaiting customer action.
          </p>
          <p class="modal-description expired-description" *ngIf="host.paymentExpired">
            The payment link has expired. Please create a new payment link.
          </p>
        </div>
      </div>

      <!-- Action Buttons -->
      <!-- <div class="payment-link-actions" *ngIf="!host.paymentExpired">
              <button class="btn-resend-link" 
                      (click)="host.onResendPaymentLink()" 
                      [disabled]="host.isCreatingPaymentLink">
                <span *ngIf="!host.isCreatingPaymentLink">Resend Link</span>
                <span *ngIf="host.isCreatingPaymentLink" class="loading-content">
                  <div class="loading-spinner"></div>
                  Sending...
                </span>
              </button>
              <button class="btn-cancel-payment" (click)="host.onCancelPaymentLink()">
                Cancel Payment
              </button>
            </div> -->
    </div>

    <!-- Checkout summary (Figma 44-32053) -->
    <div
      class="checkout-summary-toolbar"
      *ngIf="
        !host.isFamilyCheckout &&
        !(host.paymentLinkSent && host.paymentForm.method === host.PaymentMethodCode.Link)
      "
    >
      <span
        class="checkout-summary-toggle"
        (click)="host.toggleCheckoutSummary()"
        (keydown.enter)="host.toggleCheckoutSummary()"
        (keydown.space)="$event.preventDefault(); host.toggleCheckoutSummary()"
        tabindex="0"
        role="button"
      >
        {{ host.showCheckoutSummary ? 'Hide summary' : 'Show summary' }}
      </span>
    </div>
    <div
      class="checkout-summary-section"
      *ngIf="
        !host.isFamilyCheckout &&
        host.showCheckoutSummary &&
        !(host.paymentLinkSent && host.paymentForm.method === host.PaymentMethodCode.Link)
      "
    >
      <div class="checkout-summary-container">
        @if (
          host.isCheckoutPrepaidPurchase() && host.getCheckoutPrepaidSummary();
          as prepaidSummary
        ) {
          <app-prepaid-checkout-summary [summary]="prepaidSummary" />
        } @else if (host.shouldShowCheckoutServiceCard()) {
          <div class="checkout-service-card">
            <div
              class="checkout-service-card__title"
              [attr.data-fs-unmask]="host.isCheckoutMonthlyMembership() ? '' : null"
            >
              {{ host.getCheckoutPackageTitle() }}
            </div>
            <div class="checkout-service-card__rows">
              <div
                class="checkout-service-row"
                [attr.data-fs-unmask]="host.isCheckoutMonthlyMembership() ? '' : null"
              >
                <img
                  src="assets/images/payment-summary/calendar.svg"
                  alt=""
                  class="checkout-service-row__icon"
                />
                <span>{{ host.getCheckoutWashPlanLine() }}</span>
              </div>
              <div
                class="checkout-service-row"
                *ngIf="host.getCheckoutDateRangeLine() as dateLn"
                [attr.data-fs-unmask]="host.isCheckoutMonthlyMembership() ? '' : null"
              >
                <img
                  src="assets/images/payment-summary/calendar.svg"
                  alt=""
                  class="checkout-service-row__icon"
                />
                <span>{{ dateLn }}</span>
              </div>
              <div class="checkout-service-row" *ngIf="host.getCheckoutVehicleSummary() as vh">
                <img
                  src="assets/images/payment-summary/car.svg"
                  alt=""
                  class="checkout-service-row__icon"
                />
                <span>{{ vh }}</span>
              </div>
            </div>
            <div
              class="checkout-service-card__price"
              [attr.data-fs-unmask]="host.isCheckoutMonthlyMembership() ? '' : null"
            >
              <span class="checkout-service-card__amount">{{
                host.formatCheckoutServicePrice()
              }}</span>
              <span class="checkout-service-card__period" *ngIf="host.isCheckoutMonthlyMembership()"
                >/month</span
              >
            </div>
            <div
              class="checkout-membership-note"
              *ngIf="host.isCheckoutMonthlyMembership()"
              data-fs-unmask
            >
              The car wash membership auto-renews and can be managed anytime from the customer's
              account settings.
            </div>
          </div>
        }

        <ng-container *ngTemplateOutlet="wayPlusBanner" />

        <div
          class="checkout-selectable-block"
          *ngIf="host.getCheckoutRawDiscountAmount() > 0"
          [attr.data-fs-unmask]="host.isCheckoutMonthlyMembership() ? '' : null"
        >
          <div class="checkout-selectable-block__label">Discount</div>
          <div
            class="checkout-selectable-card checkout-selectable-card--discount"
            [class.checkout-selectable-card--selected]="host.checkoutSummaryDiscountSelected"
            [class.checkout-selectable-card--no-pointer]="host.getCheckoutRawDiscountAmount() <= 0"
            (click)="host.onCheckoutDiscountCardClick($event)"
            (keydown)="host.onCheckoutDiscountCardKeydown($event)"
            [attr.tabindex]="host.getCheckoutRawDiscountAmount() > 0 ? 0 : -1"
            role="checkbox"
            [attr.aria-checked]="host.checkoutSummaryDiscountSelected"
            [attr.aria-label]="'Apply discount: ' + host.getCheckoutDiscountCardTitle()"
          >
            <div class="checkout-selectable-card__main">
              <div class="checkout-selectable-card__text">
                <div class="checkout-selectable-card__title-row">
                  <span
                    class="checkout-selectable-card__title"
                    [attr.title]="host.getCheckoutDiscountCardTitle()"
                    >{{ host.getCheckoutDiscountCardTitle() }}</span
                  >
                  <span class="checkout-selectable-card__value">{{
                    host.getCheckoutDiscountCardValueLabel()
                  }}</span>
                </div>
              </div>
              <span class="checkout-selectable-card__radio" aria-hidden="true"></span>
            </div>
          </div>
        </div>

        <div
          class="checkout-selectable-block"
          *ngIf="host.getCheckoutAddonSummary() as addonSum"
          [attr.data-fs-unmask]="host.isCheckoutMonthlyMembership() ? '' : null"
        >
          <div class="checkout-selectable-block__label">
            {{ host.getCheckoutAdditionalServiceBlockLabel() }}
          </div>
          <div
            class="checkout-selectable-card checkout-selectable-card--addon"
            [class.checkout-selectable-card--selected]="host.checkoutSummaryAddonSelected"
            [class.checkout-selectable-card--no-pointer]="host.getCheckoutRawAddonAmount() <= 0"
            (click)="host.onCheckoutAddonCardClick($event)"
            (keydown)="host.onCheckoutAddonCardKeydown($event)"
            [attr.tabindex]="host.getCheckoutRawAddonAmount() > 0 ? 0 : -1"
            role="checkbox"
            [attr.aria-checked]="host.checkoutSummaryAddonSelected"
            [attr.aria-label]="'Include add-ons: ' + addonSum.label"
          >
            <div class="checkout-selectable-card__main">
              <div class="checkout-selectable-card__text">
                <div class="checkout-selectable-card__title-row">
                  <span class="checkout-selectable-card__title" [attr.title]="addonSum.label">{{
                    addonSum.label
                  }}</span>
                  <span class="checkout-selectable-card__value">{{ addonSum.priceFormatted }}</span>
                </div>
                <button
                  type="button"
                  class="checkout-selectable-card__more"
                  (click)="host.toggleCheckoutAddonDetails($event)"
                  [attr.aria-expanded]="host.checkoutAddonDetailsOpen"
                >
                  <span>{{ host.checkoutAddonDetailsOpen ? 'Hide details' : 'More details' }}</span>
                  <svg
                    class="checkout-selectable-card__more-chevron"
                    [class.checkout-selectable-card__more-chevron--open]="
                      host.checkoutAddonDetailsOpen
                    "
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M6 9L12 15L18 9"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <div
                  class="checkout-discount-details checkout-addon-details"
                  *ngIf="host.checkoutAddonDetailsOpen"
                >
                  <ng-container
                    *ngFor="let sec of host.getCheckoutAddonExpandedSections(); let last = last"
                  >
                    <div
                      class="checkout-addon-details__block"
                      [class.checkout-addon-details__block--divider]="!last"
                    >
                      <div class="checkout-addon-details__grid">
                        <div *ngFor="let c of sec.cells" class="checkout-discount-details__cell">
                          <div class="checkout-discount-details__label">{{ c.label }}</div>
                          <div class="checkout-discount-details__value">{{ c.value }}</div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
              <span class="checkout-selectable-card__radio" aria-hidden="true"></span>
            </div>
          </div>
        </div>

        <div
          class="checkout-price-breakdown"
          [attr.data-fs-unmask]="host.isCheckoutMonthlyMembership() ? '' : null"
        >
          <div class="checkout-price-row" *ngIf="host.shouldShowCheckoutServiceCard()">
            <span class="checkout-price-row__label">{{ host.getCheckoutSubtotalLineLabel() }}</span>
            <span class="checkout-price-row__value">{{
              host.formatCheckoutCurrency(host.getPaymentCheckoutBreakdown().subtotal)
            }}</span>
          </div>
          <div
            class="checkout-price-row"
            *ngIf="
              host.isCheckoutPrepaidPurchase() &&
              !host.shouldShowCheckoutServiceCard() &&
              host.getPaymentCheckoutBreakdown().subtotal > 0
            "
          >
            <span class="checkout-price-row__label">{{ host.getCheckoutSubtotalLineLabel() }}</span>
            <span class="checkout-price-row__value">{{
              host.formatCheckoutCurrency(host.getPaymentCheckoutBreakdown().subtotal)
            }}</span>
          </div>
          <div class="checkout-price-row" *ngIf="host.getPaymentCheckoutBreakdown().addon > 0">
            <span class="checkout-price-row__label">Add on products</span>
            <span class="checkout-price-row__value">{{
              host.formatCheckoutCurrency(host.getPaymentCheckoutBreakdown().addon)
            }}</span>
          </div>
          <div class="checkout-price-row" *ngIf="host.getPaymentCheckoutBreakdown().discount > 0">
            <span class="checkout-price-row__label">Discount</span>
            <span class="checkout-price-row__value checkout-price-row__value--discount">
              -{{ host.formatCheckoutCurrency(host.getPaymentCheckoutBreakdown().discount) }}
            </span>
          </div>
          <div
            class="checkout-price-row"
            *ngIf="host.getCheckoutFreeBenefitsCount() > 0 && host.isCheckoutMonthlyMembership()"
          >
            <span class="checkout-price-row__label">
              Way+ ({{ host.checkoutWayPlusStaticBenefitsCount }} Free Benefits)
            </span>
            <span class="checkout-price-row__value">{{
              host.formatCheckoutCurrency(host.getPaymentCheckoutBreakdown().wayPlus)
            }}</span>
          </div>
          <div class="checkout-price-row">
            <button type="button" class="checkout-price-row__label checkout-price-row__label--link">
              Taxes and Fees
            </button>
            <span class="checkout-price-row__value">{{
              host.formatCheckoutCurrency(host.getPaymentCheckoutBreakdown().tax)
            }}</span>
          </div>
          <div class="checkout-price-row" *ngIf="host.hasCheckoutTerminalConvenienceFee()">
            <span class="checkout-price-row__label">Convenience fee</span>
            <span class="checkout-price-row__value">{{
              host.formatCheckoutCurrency(host.getTerminalConvenienceFeeAmount())
            }}</span>
          </div>
          <div class="checkout-price-row checkout-price-row--total">
            <span class="checkout-price-row__label">Grand Total</span>
            <span class="checkout-price-row__value">{{
              host.formatCheckoutCurrency(host.getCheckoutSummaryGrandTotal())
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Family Plan sale (CWS-1580): one row per plate, totals from the server quote -->
    <div class="checkout-summary-section" *ngIf="host.isFamilyCheckout" data-fs-unmask>
      <div class="checkout-summary-container">
        <div class="checkout-service-card family-checkout-card">
          <div class="checkout-service-card__title">Family Plan</div>
          <div class="family-checkout-rows" role="table" aria-label="Family Plan plates">
            <div class="family-checkout-row family-checkout-row--head" role="row">
              <div role="columnheader">License plate</div>
              <div role="columnheader">Car wash package</div>
              <div role="columnheader">Customer name</div>
              <div role="columnheader">Price</div>
            </div>
            <div
              class="family-checkout-row"
              role="row"
              *ngFor="let row of host.familyCheckoutRowsData"
            >
              <div class="family-checkout-row__plate" role="cell">
                <span class="family-checkout-row__label">License plate</span>
                <span class="family-checkout-row__plate-chip">{{ row.plate }}</span>
                <span class="family-checkout-row__tag" *ngIf="row.role === 'primary'">Primary</span>
              </div>
              <div class="family-checkout-row__package" role="cell">
                {{ row.packageName }}
              </div>
              <div class="family-checkout-row__customer" role="cell">
                <span class="family-checkout-row__label">Customer name</span>
                {{ row.customerName }}
              </div>
              <div class="family-checkout-row__price" role="cell">
                <span class="family-checkout-row__label">Price</span>
                {{ host.formatCheckoutCurrency(row.price) }}/mo
                <s *ngIf="row.discounted">{{ host.formatCheckoutCurrency(row.listPrice) }}/mo</s>
              </div>
            </div>
          </div>
          <div class="checkout-membership-note">
            The car wash membership auto-renews and can be managed anytime from the customer's
            account settings.
          </div>
        </div>

        <ng-container *ngTemplateOutlet="wayPlusBanner" />

        <div class="checkout-price-breakdown" *ngIf="host.familyBreakdown as fb">
          <div class="checkout-price-row">
            <span class="checkout-price-row__label">Subtotal</span>
            <span class="checkout-price-row__value">{{
              host.formatCheckoutCurrency(fb.subtotal)
            }}</span>
          </div>
          <div class="checkout-price-row" *ngIf="fb.addon > 0">
            <span class="checkout-price-row__label">Add on products</span>
            <span class="checkout-price-row__value">{{
              host.formatCheckoutCurrency(fb.addon)
            }}</span>
          </div>
          <div class="checkout-price-row" *ngIf="fb.discount > 0">
            <span class="checkout-price-row__label">Discount</span>
            <span class="checkout-price-row__value checkout-price-row__value--discount">
              -{{ host.formatCheckoutCurrency(fb.discount) }}
            </span>
          </div>
          <div class="checkout-price-row" *ngIf="host.shouldShowCheckoutWayPlusBanner()">
            <span class="checkout-price-row__label">
              Way+ ({{ host.checkoutWayPlusStaticBenefitsCount }} Free Benefits)
            </span>
            <span class="checkout-price-row__value">{{ host.formatCheckoutCurrency(0) }}</span>
          </div>
          <div class="checkout-price-row checkout-price-row--total">
            <span class="checkout-price-row__label">Grand Total</span>
            <span class="checkout-price-row__value">{{
              host.formatCheckoutCurrency(fb.total)
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="payment-methods-notice" *ngIf="host.isFamilyPaymentMethodUnsupported">
      This payment method is not available for Family Plan yet. Use Card Payment.
    </div>

    <p
      class="checkout-zero-balance-note"
      *ngIf="
        !host.isCheckoutPaymentRequired() &&
        !(host.paymentLinkSent && host.paymentForm.method === host.PaymentMethodCode.Link)
      "
    >
      No payment is required for this order. Use <strong>Complete order</strong> below.
    </p>

    <p
      class="checkout-zero-balance-note"
      *ngIf="
        !host.isFamilyCheckout &&
        host.isZeroDueCardOnFileCheckout() &&
        !(host.paymentLinkSent && host.paymentForm.method === host.PaymentMethodCode.Link)
      "
    >
      No charge today — the discount covers the first month. A card is still required to bill future
      renewals.
    </p>

    <!-- Why a method is missing from the grid below. Sits above the tiles rather than inside the
         Card tile: it explains the checkout as a whole, and a notice crammed into one tile made
         that tile taller than its neighbours and pushed the grid out of alignment. -->
    <div
      class="payment-methods-notice"
      *ngIf="host.isCheckoutPaymentRequired() && host.isCardPaymentDisabled()"
    >
      {{ host.cardPaymentUnavailableMessage }}
    </div>

    <!-- Payment Method Selection -->
    <div
      class="payment-methods"
      role="radiogroup"
      aria-label="Payment method"
      [class.compact]="host.showMorePaymentMethods"
      *ngIf="
        host.isCheckoutPaymentRequired() &&
        !(host.paymentLinkSent && host.paymentForm.method === host.PaymentMethodCode.Link)
      "
    >
      <!-- Tap to Pay - Disabled on desktop, enabled on mobile/tablet devices -->
      <div
        class="payment-method"
        role="radio"
        [class.selected]="host.paymentForm.method === host.PaymentMethodCode.TapToPay"
        [class.disabled]="!host.isMobileOrTablet || host.areStripePaymentMethodsDisabled()"
        [attr.aria-checked]="host.paymentForm.method === host.PaymentMethodCode.TapToPay"
        [attr.aria-disabled]="!host.isMobileOrTablet || host.areStripePaymentMethodsDisabled()"
        [attr.aria-label]="'Tap to Pay'"
        [attr.tabindex]="host.isMobileOrTablet && !host.areStripePaymentMethodsDisabled() ? 0 : -1"
        (click)="
          !host.isMobileOrTablet ? null : host.selectPaymentMethod(host.PaymentMethodCode.TapToPay)
        "
        (keydown.enter)="
          !host.isMobileOrTablet ? null : host.selectPaymentMethod(host.PaymentMethodCode.TapToPay)
        "
        (keydown.space)="
          $event.preventDefault();
          !host.isMobileOrTablet ? null : host.selectPaymentMethod(host.PaymentMethodCode.TapToPay)
        "
      >
        <div class="method-content">
          <div class="method-icon" *ngIf="!host.showMorePaymentMethods">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4Z"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="none"
              />
              <path
                d="M6 10H18"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8 14C8.55228 14 9 13.5523 9 13C9 12.4477 8.55228 12 8 12C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14Z"
                fill="currentColor"
              />
              <path
                d="M12 14C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13C11 13.5523 11.4477 14 12 14Z"
                fill="currentColor"
              />
              <path
                d="M16 14C16.5523 14 17 13.5523 17 13C17 12.4477 16.5523 12 16 12C15.4477 12 15 12.4477 15 13C15 13.5523 15.4477 14 16 14Z"
                fill="currentColor"
              />
              <path
                d="M19 7H5"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="method-info">
            <div class="method-title">Tap to Pay</div>
            <div class="method-description">Open the app to process payment</div>
          </div>
        </div>
        <div
          class="method-radio"
          [class.checked]="host.paymentForm.method === host.PaymentMethodCode.TapToPay"
        ></div>
      </div>

      <!-- Terminal (POS Reader) -->
      <div
        class="payment-method"
        *ngIf="host.shouldShowTerminalPaymentMethod()"
        role="radio"
        [class.selected]="host.paymentForm.method === host.PaymentMethodCode.Terminal"
        [class.disabled]="
          !host.isTerminalPaymentMethodEnabled() || host.areStripePaymentMethodsDisabled()
        "
        [class.has-terminal-tip]="host.shouldShowTerminalReaderNotice()"
        [attr.data-terminal-tip]="
          host.shouldShowTerminalReaderNotice() ? host.getTerminalReaderUnavailableMessage() : null
        "
        [attr.aria-checked]="host.paymentForm.method === host.PaymentMethodCode.Terminal"
        [attr.aria-disabled]="
          !host.isTerminalPaymentMethodEnabled() || host.areStripePaymentMethodsDisabled()
        "
        [attr.aria-label]="'Terminal'"
        [attr.tabindex]="
          host.isTerminalPaymentMethodEnabled() && !host.areStripePaymentMethodsDisabled() ? 0 : -1
        "
        (click)="
          host.isTerminalPaymentMethodEnabled() &&
            host.selectPaymentMethod(host.PaymentMethodCode.Terminal)
        "
        (keydown.enter)="
          host.isTerminalPaymentMethodEnabled() &&
            host.selectPaymentMethod(host.PaymentMethodCode.Terminal)
        "
        (keydown.space)="
          $event.preventDefault();
          host.isTerminalPaymentMethodEnabled() &&
            host.selectPaymentMethod(host.PaymentMethodCode.Terminal)
        "
      >
        <div class="method-content">
          <div class="method-icon" *ngIf="!host.showMorePaymentMethods">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="4"
                y="3"
                width="16"
                height="18"
                rx="2"
                stroke="currentColor"
                stroke-width="1.5"
              />
              <path d="M8 7H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              <path d="M8 11H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              <circle cx="16" cy="16" r="2" stroke="currentColor" stroke-width="1.5" />
            </svg>
          </div>
          <div class="method-info">
            <div class="method-title">Terminal</div>
            <div class="method-description">{{ host.getTerminalMethodDescription() }}</div>
          </div>
        </div>
        <div
          class="method-radio"
          [class.checked]="host.paymentForm.method === host.PaymentMethodCode.Terminal"
        ></div>
      </div>

      <div
        class="payment-method"
        role="radio"
        [class.selected]="host.paymentForm.method === host.PaymentMethodCode.Cash"
        [class.disabled]="host.isCashPaymentDisabled() || host.arePaymentMethodsDisabled()"
        [attr.aria-checked]="host.paymentForm.method === host.PaymentMethodCode.Cash"
        [attr.aria-disabled]="host.isCashPaymentDisabled() || host.arePaymentMethodsDisabled()"
        [attr.aria-label]="'Cash'"
        [attr.tabindex]="host.isCashPaymentDisabled() || host.arePaymentMethodsDisabled() ? -1 : 0"
        (click)="
          !host.isCashPaymentDisabled() && host.selectPaymentMethod(host.PaymentMethodCode.Cash)
        "
        (keydown.enter)="
          !host.isCashPaymentDisabled() && host.selectPaymentMethod(host.PaymentMethodCode.Cash)
        "
        (keydown.space)="
          $event.preventDefault();
          !host.isCashPaymentDisabled() && host.selectPaymentMethod(host.PaymentMethodCode.Cash)
        "
      >
        <div class="method-content">
          <div class="method-icon" *ngIf="!host.showMorePaymentMethods">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.72-2.92-.01-1.56-1.19-2.45-3.61-3.01z"
                fill="currentColor"
              />
            </svg>
          </div>
          <div class="method-info">
            <div class="method-title">Cash</div>
            <div class="method-description">Confirm cash payment received</div>
          </div>
        </div>
        <div
          class="method-radio"
          [class.checked]="host.paymentForm.method === host.PaymentMethodCode.Cash"
        ></div>
      </div>

      <div
        class="payment-method"
        role="radio"
        [class.selected]="host.paymentForm.method === host.PaymentMethodCode.Card"
        [class.disabled]="host.isCardPaymentDisabled()"
        [attr.aria-checked]="host.paymentForm.method === host.PaymentMethodCode.Card"
        [attr.aria-disabled]="host.isCardPaymentDisabled()"
        [attr.aria-label]="'Card Payment'"
        [attr.tabindex]="host.isCardPaymentDisabled() ? -1 : 0"
        (click)="
          !host.isCardPaymentDisabled() && host.selectPaymentMethod(host.PaymentMethodCode.Card)
        "
        (keydown.enter)="
          !host.isCardPaymentDisabled() && host.selectPaymentMethod(host.PaymentMethodCode.Card)
        "
        (keydown.space)="
          $event.preventDefault();
          !host.isCardPaymentDisabled() && host.selectPaymentMethod(host.PaymentMethodCode.Card)
        "
      >
        <div class="method-content">
          <div class="method-icon" *ngIf="!host.showMorePaymentMethods">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="3"
                y="5"
                width="18"
                height="14"
                rx="2"
                stroke="currentColor"
                stroke-width="1.5"
              />
              <line x1="3" y1="9" x2="21" y2="9" stroke="currentColor" stroke-width="1.5" />
            </svg>
          </div>
          <div class="method-info">
            <div class="method-title">Card Payment</div>
            <div class="method-description">Enter card details to make payment</div>
          </div>
        </div>
        <div
          class="method-radio"
          [class.checked]="host.paymentForm.method === host.PaymentMethodCode.Card"
        ></div>
      </div>

      <!-- Additional Payment Methods (shown when expanded) - All in same grid -->
      <div
        class="payment-method"
        *ngIf="host.showMorePaymentMethods"
        role="radio"
        [class.selected]="host.paymentForm.method === host.PaymentMethodCode.Link"
        [class.disabled]="host.isPaymentLinkDisabled()"
        [attr.aria-checked]="host.paymentForm.method === host.PaymentMethodCode.Link"
        [attr.aria-disabled]="host.isPaymentLinkDisabled()"
        [attr.aria-label]="'Payment Link'"
        [attr.tabindex]="host.isPaymentLinkDisabled() ? -1 : 0"
        (click)="
          !host.isPaymentLinkDisabled() && host.selectPaymentMethod(host.PaymentMethodCode.Link)
        "
        (keydown.enter)="
          !host.isPaymentLinkDisabled() && host.selectPaymentMethod(host.PaymentMethodCode.Link)
        "
        (keydown.space)="
          $event.preventDefault();
          !host.isPaymentLinkDisabled() && host.selectPaymentMethod(host.PaymentMethodCode.Link)
        "
      >
        <div class="method-content">
          <div class="method-icon" *ngIf="!host.showMorePaymentMethods">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="method-info">
            <div class="method-title">Payment Link</div>
            <div class="method-description">Send payment link to customer</div>
          </div>
        </div>
        <div
          class="method-radio"
          [class.checked]="host.paymentForm.method === host.PaymentMethodCode.Link"
        ></div>
      </div>

      <ng-container *ngIf="host.showMorePaymentMethods">
        <div
          class="payment-method"
          *ngFor="let method of host.filteredDynamicPaymentMethodOptions"
          role="radio"
          [class.selected]="host.isDynamicPaymentMethodSelected(method.name)"
          [attr.aria-checked]="host.isDynamicPaymentMethodSelected(method.name)"
          [class.disabled]="host.arePaymentMethodsDisabled()"
          [attr.aria-label]="method.name"
          [attr.aria-disabled]="host.arePaymentMethodsDisabled()"
          [attr.tabindex]="host.arePaymentMethodsDisabled() ? -1 : 0"
          (click)="!host.arePaymentMethodsDisabled() && host.selectPaymentMethod(method.name)"
          (keydown.enter)="host.selectPaymentMethod(method.name)"
          (keydown.space)="$event.preventDefault(); host.selectPaymentMethod(method.name)"
        >
          <div class="method-content">
            <div class="method-icon" *ngIf="!host.showMorePaymentMethods">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2L2 7L12 12L22 7L12 2Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2 17L12 22L22 17"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2 12L12 17L22 12"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="method-info">
              <div class="method-title">{{ method.name }}</div>
              <div class="method-description">Confirm payment using {{ method.name }}</div>
            </div>
          </div>
          <div
            class="method-radio"
            [class.checked]="host.isDynamicPaymentMethodSelected(method.name)"
          ></div>
        </div>
      </ng-container>
      <div class="more-payment-methods-toggle" (click)="host.toggleMorePaymentMethods()">
        <span>{{
          host.showMorePaymentMethods ? 'Less Payment Methods' : 'More Payment Methods'
        }}</span>
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          [class.rotated]="host.showMorePaymentMethods"
        >
          <path
            d="M6 9L12 15L18 9"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>

    <div
      class="checkout-terminal-section"
      *ngIf="
        host.isCheckoutPaymentRequired() &&
        host.paymentForm.method === host.PaymentMethodCode.Terminal
      "
    >
      <div class="checkout-terminal-section__header">
        <span class="checkout-terminal-section__title">Terminal payment</span>
        <span class="checkout-terminal-section__subtitle"
          >Send the charge to a POS reader to collect payment.</span
        >
      </div>

      <div class="form-row">
        <div class="form-field">
          <label class="field-label" for="checkoutTerminalReaderDropdown"
            >Select reader<span class="asterisk">*</span></label
          >
          <div
            id="checkoutTerminalReaderDropdown"
            class="checkout-terminal-dropdown"
            [class.open]="host.isTerminalReaderDropdownOpen"
            tabindex="0"
            role="button"
            [attr.aria-expanded]="host.isTerminalReaderDropdownOpen"
            aria-label="Select reader"
            (click)="host.toggleTerminalReaderDropdown($event)"
            (blur)="host.closeTerminalReaderDropdown()"
          >
            <div class="checkout-terminal-dropdown__selected">
              <span class="checkout-terminal-dropdown__value-row">
                <span
                  *ngIf="host.hasSelectedTerminalReader()"
                  class="checkout-terminal-status-dot"
                  [class.checkout-terminal-status-dot--online]="
                    host.isTerminalReaderOnline(host.paymentForm.terminalReaderId)
                  "
                  [class.checkout-terminal-status-dot--offline]="
                    !host.isTerminalReaderOnline(host.paymentForm.terminalReaderId)
                  "
                  aria-hidden="true"
                ></span>
                <span
                  class="checkout-terminal-dropdown__value"
                  [class.checkout-terminal-dropdown__value--placeholder]="
                    !host.hasSelectedTerminalReader()
                  "
                  >{{ host.getSelectedTerminalReaderLabel() }}</span
                >
              </span>
              <svg
                class="checkout-terminal-dropdown__arrow"
                [class.rotated]="host.isTerminalReaderDropdownOpen"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M6 9L12 15L18 9"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div
              class="checkout-terminal-dropdown__menu"
              *ngIf="host.isTerminalReaderDropdownOpen"
              (mousedown)="$event.preventDefault()"
            >
              <div
                *ngFor="let reader of host.terminalReaders"
                class="checkout-terminal-dropdown__option"
                [class.selected]="reader.id === host.paymentForm.terminalReaderId"
                [class.disabled]="reader.status !== 'online'"
                (click)="host.selectTerminalReaderOption(reader, $event)"
              >
                <span
                  class="checkout-terminal-status-dot"
                  [class.checkout-terminal-status-dot--online]="reader.status === 'online'"
                  [class.checkout-terminal-status-dot--offline]="reader.status !== 'online'"
                  aria-hidden="true"
                ></span>
                <span class="checkout-terminal-dropdown__option-label">{{
                  host.getTerminalReaderLabel(reader)
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="form-field">
          <label class="field-label" for="checkoutTerminalCardTypeDropdown"
            >Card type<span class="asterisk">*</span></label
          >
          <div
            id="checkoutTerminalCardTypeDropdown"
            class="checkout-terminal-dropdown"
            [class.open]="host.isTerminalCardTypeDropdownOpen"
            tabindex="0"
            role="button"
            [attr.aria-expanded]="host.isTerminalCardTypeDropdownOpen"
            aria-label="Select card type"
            (click)="host.toggleTerminalCardTypeDropdown($event)"
            (blur)="host.closeTerminalCardTypeDropdown()"
          >
            <div class="checkout-terminal-dropdown__selected">
              <span class="checkout-terminal-dropdown__value">{{
                host.getSelectedTerminalCardTypeLabel()
              }}</span>
              <svg
                class="checkout-terminal-dropdown__arrow"
                [class.rotated]="host.isTerminalCardTypeDropdownOpen"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M6 9L12 15L18 9"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div
              class="checkout-terminal-dropdown__menu"
              *ngIf="host.isTerminalCardTypeDropdownOpen"
              (mousedown)="$event.preventDefault()"
            >
              <div
                *ngFor="let option of host.terminalCardTypeOptions"
                class="checkout-terminal-dropdown__option"
                [class.selected]="option.value === host.paymentForm.terminalCardType"
                (click)="host.selectTerminalCardTypeOption(option.value, $event)"
              >
                <span class="checkout-terminal-dropdown__option-label">{{ option.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p
        class="checkout-terminal-offline-note"
        *ngIf="
          host.paymentForm.terminalReaderId &&
          !host.isTerminalReaderOnline(host.paymentForm.terminalReaderId)
        "
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path d="M12 9V13" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          <circle cx="12" cy="16.5" r="1" fill="currentColor" />
          <path
            d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>Selected reader is offline. Choose an online reader to collect payment.</span>
      </p>
    </div>

    <div
      class="checkout-cash-due-section"
      *ngIf="
        host.isCheckoutPaymentRequired() &&
        host.notification?.type === 'create-payment-request' &&
        host.paymentForm.method === host.PaymentMethodCode.Cash
      "
    >
      <div class="checkout-cash-panel">
        <div class="checkout-cash-panel__presets">
          <div class="checkout-cash-panel__section-label">Tap to add amount</div>
          <div class="checkout-cash-panel__preset-row" role="group" aria-label="Tap to add amount">
            <app-cash-preset-button
              *ngFor="let amount of host.checkoutCashPresetAmounts"
              [amount]="amount"
              [count]="host.getCheckoutCashPresetCount(amount)"
              (add)="host.addCheckoutCashPreset(amount)"
              (increment)="host.adjustCheckoutCashPresetByAmount(amount, 1)"
              (decrement)="host.adjustCheckoutCashPresetByAmount(amount, -1)"
            ></app-cash-preset-button>
          </div>
        </div>

        <div class="checkout-cash-panel__manual">
          <div class="checkout-cash-panel__section-label">Or enter cash received</div>
          <div class="checkout-cash-panel__manual-row">
            <div class="checkout-cash-manual-field">
              <label class="checkout-cash-manual-field__label" for="checkoutCashDollarsInput"
                >Dollars ($)</label
              >
              <input
                id="checkoutCashDollarsInput"
                type="text"
                class="checkout-cash-manual-field__input"
                [class.checkout-cash-manual-field__input--error]="
                  host.isCheckoutCashReceivedFieldInError()
                "
                [attr.aria-invalid]="host.isCheckoutCashReceivedFieldInError() ? 'true' : null"
                placeholder="0"
                inputmode="numeric"
                pattern="[0-9]*"
                maxlength="7"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                data-lpignore="true"
                data-1p-ignore="true"
                name="checkout-cash-dollars"
                [value]="host.getCheckoutCashReceivedDollarsDisplay()"
                (keydown)="host.onCheckoutCashAmountKeydown($event)"
                (paste)="host.onCheckoutCashDollarsPaste($event)"
                (input)="
                  host.onCheckoutCashDollarsInput($any($event.target).value, $any($event.target))
                "
              />
            </div>
            <div class="checkout-cash-manual-field">
              <label class="checkout-cash-manual-field__label" for="checkoutCashCentsInput"
                >Cents (¢)</label
              >
              <input
                id="checkoutCashCentsInput"
                type="text"
                class="checkout-cash-manual-field__input"
                [class.checkout-cash-manual-field__input--error]="
                  host.isCheckoutCashReceivedFieldInError()
                "
                [attr.aria-invalid]="host.isCheckoutCashReceivedFieldInError() ? 'true' : null"
                placeholder="00"
                inputmode="numeric"
                pattern="[0-9]*"
                maxlength="2"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                data-lpignore="true"
                data-1p-ignore="true"
                name="checkout-cash-cents"
                [value]="host.getCheckoutCashReceivedCentsDisplay()"
                (keydown)="host.onCheckoutCashAmountKeydown($event)"
                (paste)="host.onCheckoutCashCentsPaste($event)"
                (input)="
                  host.onCheckoutCashCentsInput($any($event.target).value, $any($event.target))
                "
              />
            </div>
          </div>
        </div>

        <div class="checkout-cash-panel__summary">
          <div class="checkout-cash-panel__summary-row">
            <span class="checkout-cash-panel__summary-label">Cash received</span>
            <span class="checkout-cash-panel__summary-value">{{
              host.getCheckoutCashReceivedSummaryLabel()
            }}</span>
          </div>
          <div
            class="checkout-cash-panel__summary-row"
            *ngIf="host.isCheckoutCashChangeDueVisible()"
          >
            <span class="checkout-cash-panel__summary-label">Change due</span>
            <span
              class="checkout-cash-panel__summary-value checkout-cash-panel__summary-value--change"
            >
              {{ host.getCheckoutCashChangeDueLabel() }}
            </span>
          </div>
          <div
            class="checkout-cash-panel__error"
            *ngIf="host.isCheckoutCashUnderTender()"
            role="alert"
          >
            {{ host.getCheckoutCashMinimumRequiredMessage() }}
          </div>
          <div class="checkout-cash-panel__summary-row checkout-cash-panel__summary-row--total">
            <span class="checkout-cash-panel__summary-label">Grand Total</span>
            <span class="checkout-cash-panel__summary-value">{{
              host.formatCheckoutCurrency(host.getCheckoutAmountDueTotal())
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Card Payment Form - Only shown when card payment is selected AND this location can take a
         card. Not rendered rather than disabled: the number, expiry and CVC are Stripe Elements
         mounted into #card-number / #card-expiry / #card-cvc, which are cross-origin iframes and
         cannot be switched off by a template binding — only by an Elements API call. Leaving them
         live while the payment cannot complete is what let an attendant type a whole card in. -->
    <div
      *ngIf="
        host.isCheckoutPaymentRequired() &&
        host.paymentForm.method === host.PaymentMethodCode.Card &&
        !host.isCardPaymentDisabled()
      "
      class="card-payment-form"
      data-fs-mask
    >
      <!-- Card payment form with regular input fields -->
      <div class="stripe-form-container">
        <!-- Name on card and Card number in the same row -->
        <div class="form-row">
          <div class="form-field">
            <label class="field-label">Name on card<span class="asterisk">*</span></label>
            <div class="stripe-input-container">
              <input
                type="text"
                class="stripe-input-field"
                placeholder="e.g. John Smith"
                autocomplete="cc-name"
                [(ngModel)]="host.paymentForm.cardholderName"
                name="cardholderName"
              />
            </div>
          </div>

          <div class="form-field">
            <label class="field-label">Card number<span class="asterisk">*</span></label>
            <div class="stripe-input-container">
              <!-- For stripe changed[nov-18-2025] -->
              <div id="card-number" class="stripe-input-field"></div>
            </div>
            <div id="card-number-error" class="field-error" role="alert"></div>
          </div>
        </div>

        <!-- Expiration and CVC in a row -->
        <div class="form-row">
          <div class="form-field">
            <label class="field-label">Expiration<span class="asterisk">*</span></label>
            <div class="stripe-input-container">
              <div id="card-expiry" class="stripe-input-field"></div>
            </div>
            <div id="card-expiry-error" class="field-error" role="alert"></div>
          </div>
          <div class="form-field">
            <label class="field-label">CVC<span class="asterisk">*</span></label>
            <div class="stripe-input-container">
              <div id="card-cvc" class="stripe-input-field"></div>
            </div>
            <div id="card-cvc-error" class="field-error" role="alert"></div>
          </div>
        </div>

        <!-- Billing address field -->
        <div class="form-field">
          <label class="field-label">Billing address</label>
          <div class="stripe-input-container">
            <input
              type="text"
              class="stripe-input-field"
              placeholder="e.g. 122B, Baker Street, NYC"
              [(ngModel)]="host.paymentForm.billingAddress"
              name="billingAddress"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Phone Number Field - Only shown for payment link -->
    <div
      *ngIf="
        host.isCheckoutPaymentRequired() &&
        host.paymentForm.method === host.PaymentMethodCode.Link &&
        !host.paymentLinkSent
      "
      class="phone-input-section"
    >
      <app-custom-input
        label="Phone Number"
        placeholder="e.g. (212) 555-1234"
        type="tel"
        inputMode="numeric"
        [required]="true"
        [validationRules]="host.paymentPhoneValidation"
        [showValidation]="true"
        [markTouchedOnInput]="true"
        [(value)]="host.paymentForm.phoneNumber"
      >
      </app-custom-input>
    </div>
  </div>
</div>

<ng-template #wayPlusBanner>
  <div
    class="checkout-benefits-banner"
    *ngIf="host.shouldShowCheckoutWayPlusBanner()"
    data-fs-unmask
  >
    <div class="checkout-benefits-banner__head">
      <span class="checkout-benefits-banner__intro">The Customer Gets</span>
      <button
        type="button"
        class="checkout-benefits-banner__benefits-link"
        (click)="host.openCheckoutWayPlusBenefitsModal()"
        [attr.aria-label]="'View ' + host.checkoutWayPlusStaticBenefitsCount + ' Way+ benefits'"
      >
        {{ host.checkoutWayPlusStaticBenefitsCount }} Benefits
      </button>
      <span class="checkout-benefits-banner__tag">Free</span>
    </div>
    <div class="checkout-benefits-banner__note">
      All the free benefits are valid for one month from the purchase date.
    </div>
  </div>
</ng-template>
